<template>
  <main v-if='kirby.page.intendedTemplate == "profile"'>
    <header>
      <nav>
        <router-link class='prev' v-if='kirby.page.prev' :to='"/"+kirby.page.prev'>
          <span v-html='pageFromURI(kirby.page.prev).strings.title' />
        </router-link>
        <router-link class='next' v-if='kirby.page.next' :to='"/"+kirby.page.next'>
          <span class='next' v-html='pageFromURI(kirby.page.next).strings.title' />
        </router-link>
      </nav>
      <close />
    </header>
    <section>
      <div>
        <h1 v-html='kirby.page.content.title.value' />
        <!--<h5 v-html='kirby.page.strings.info' />-->
        <gallery v-if='kirby.page.strings.files' :filenames='yaml(kirby.page.strings.files)' :page='kirby.page' />
      </div>
      <div v-if="kirby.page.content.bio">
        <article v-html='kirby.page.content.bio.kirbytext' />
      </div>
    </section>
  </main>
</template>

<script>
import mixins from '.././mixins.js';

export default {
  mixins: [mixins], //kirby(), urltopath(), etc
  mounted: function(){
    this.$emit("addReasonToShowVeil");
  },
  destroyed: function(){
    this.$emit("removeReasonToShowVeil");
  },
}
</script>

<style scoped>

  main {;
    padding-top: 7rem !important;
    box-sizing: border-box;
  }

  h1 {
    margin-top: 0.75rem;
    margin-bottom: 1rem;
    margin-left: -0.01em;
  }

  header {
    position: absolute;
    z-index: 99;
    background-color: white;
    height: 6rem;
    top: 0rem;
    left: 0rem;
    right: 0rem;
  }

  header nav {
    padding: 2rem 3.5rem;
    display: flex;
  }

  header nav a {
    margin-right: 2rem;
    user-select: none;
  }

  header nav a span {
    display: var(--inlineblockondesktop);
  }

  header nav a.prev::before {
    content: "← Previous";
  }

  header nav a span::before {
    content: ": ";
  }


  header nav a.next::before {
    content: "Next";
  }

  header nav a.next::after {
    content: " →";
  }

  section {
    width: 100%;
    color: var(--darkgray);
    display: flex;
    flex-direction: var(--columndirection);
  }

  section div {
    width: var(--columnsondesktop);
    box-sizing: border-box;
    padding-right: 5rem;
  }

</style>

<style>

article a {
  color: var(darkgray);
  text-decoration: underline;
}

</style>
